export const waitForTimeout = async (timeout: number): Promise<void> => {
    let timeoutId;
    await new Promise((resolve, _) => {
        timeoutId = setTimeout(resolve, timeout);
    });

    clearTimeout(timeoutId);
};
